import { BasisPoints } from '@klear/basis-points'

export function funderToJson(funder: Funder) {
  return {
    funderId: funder.funderId,
    organizationId: funder.organizationId,
    organizationName: funder.organizationName,
    klearBankAccountId: funder.klearBankAccountId,
    funderRate: funder.funderRate.value,
    supportsIG: funder.supportsIG,
    supportsInsured: funder.supportsInsured
  }
}
export type FunderJson = ReturnType<typeof funderToJson>

export class Funder {
  static readonly __klearClass = 'Funder'

  funderId: number
  organizationId: number
  organizationName: string
  klearBankAccountId: number | null
  funderRate: BasisPoints
  supportsIG: boolean
  supportsInsured: boolean

  constructor(props: FunderJson) {
    this.funderId = props.funderId
    this.organizationId = props.organizationId
    this.organizationName = props.organizationName
    this.klearBankAccountId = props.klearBankAccountId ?? null
    this.funderRate = new BasisPoints(props.funderRate ?? 0)
    this.supportsIG = props.supportsIG ?? false
    this.supportsInsured = props.supportsInsured ?? false

    this.assertValid()
  }

  get id(): number {
    return this.funderId
  }

  assertValid(): void {
    if (!this.organizationId) {
      throw new Error('Funder organizationId is required')
    }
  }

  toJSON() {
    return funderToJson(this)
  }
}
